import Entities from './Entities'
import ACLService from 'Services/ACL_Service'

export default ({ getFunctions, addFunction, setWriteAccess, removeFunction }) ->
  Entities({
    addEntity: addFunction
    allEntities: -> ACLService.loadFunctionAcls()
    entityFilter: (value, acl) ->
      acl.id().toLowerCase().includes(value.toLowerCase())
    comparator: (fnAcl) -> fnAcl.id()
    sortBy: (fnAcl) -> fnAcl.id()
    getEntities: getFunctions
    removeEntity: removeFunction
    setWriteAccess: setWriteAccess
    title: 'permissions'
    titleRenderer: (item) -> item.id()
  })
